var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFluShot = function SvgFluShot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 108 108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".flu_shot{fill:none;stroke:#f9f9fa;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flu_Shot",
    "data-name": "Flu Shot"
  }, /*#__PURE__*/React.createElement("line", {
    className: "flu_shot",
    x1: 59.38,
    y1: 32.9,
    x2: 74.18,
    y2: 47.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "flu_shot",
    x: 49.25,
    y: 35.7,
    width: 12.88,
    height: 31.38,
    transform: "translate(52.65 -24.32) rotate(45)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "flu_shot",
    x1: 71.33,
    y1: 27.78,
    x2: 79.3,
    y2: 35.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "flu_shot",
    x1: 66.78,
    y1: 40.3,
    x2: 75.31,
    y2: 31.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "flu_shot",
    points: "42.31 67.04 40.04 64.77 42.88 60.78 46.3 64.2 42.31 67.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "flu_shot",
    x1: 41.17,
    y1: 65.9,
    x2: 28.66,
    y2: 78.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "flu_shot",
    x1: 48,
    y1: 59.08,
    x2: 51.99,
    y2: 63.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "flu_shot",
    x1: 51.42,
    y1: 55.66,
    x2: 55.4,
    y2: 59.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "flu_shot",
    x1: 54.83,
    y1: 52.25,
    x2: 58.81,
    y2: 56.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "flu_shot",
    x1: 58.24,
    y1: 48.83,
    x2: 62.23,
    y2: 52.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "flu_shot",
    x1: 61.66,
    y1: 45.42,
    x2: 65.64,
    y2: 49.4
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFluShot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flu_shot.6cb984fd.svg";
export { ForwardRef as ReactComponent };